@defer (when events$ | async){
<app-boilerplate >
  <div class="flex justify-between">
    <h1>Upcoming Events</h1>
    @if (!eventSystem) {
      @if (eventSystems$ | async; as eventSystemList){
        <form class="hidden md:block" action="" [formGroup]="formGroup">
          <p-multiSelect formControlName="selectedEventSystems" styleClass="inline-block h-9 text-sm shadow-md" placeholder="Filter by Event System" [options]="eventSystemList" optionLabel="name" />
        </form>
      }
    }
  </div>
  @if ((events$ | async); as events) {
    <app-events-summary-list [eventList]="events ?? []"/>
  }
</app-boilerplate>
}
@placeholder {
<app-loading />
}